import { CLASSIFICATION_LABELS } from '../../constants/parameters.constants';
import type { StateReferenceFixedClass } from '../../types/parameters.types';
import { getClassLevel } from '../../utils/classLevel';
import { ValueInput } from '../Forms/ValueInput';
import tableStyles from '../Tables/ParamsTable.module.css';
import styles from './Sections.module.css';

interface ClassLimitsFieldsProps {
	classes: StateReferenceFixedClass[];
	onChange: (classes: StateReferenceFixedClass[]) => void;
}

const LEVEL_BADGE = {
	low: tableStyles.badgeLow,
	medium: tableStyles.badgeMedium,
	high: tableStyles.badgeHigh,
};

export const ClassLimitsFields = ({ classes, onChange }: ClassLimitsFieldsProps) => {
	const setBoundary = (index: number, value: number | undefined) =>
		onChange(
			classes.map((item, i) => {
				if (i === index) return { ...item, maxValue: value };
				if (i === index + 1) return { ...item, minValue: value };
				return item;
			})
		);

	return (
		<div className={styles.classGrid}>
			<span className={styles.classHeader}>Classe</span>
			<span className={styles.classHeader}>A partir de</span>
			<span className={styles.classHeader}>Até</span>
			{classes.map((item, i) => {
				const name = CLASSIFICATION_LABELS[item.classification];
				return (
					<div key={item.classification} className={styles.classRow}>
						<span>
							<span className={`${tableStyles.badge} ${LEVEL_BADGE[getClassLevel(item.classification)]}`}>{name}</span>
						</span>
						{i === 0 ? (
							<span className={styles.classEmpty}>—</span>
						) : (
							<ValueInput
								label={`${name} - a partir de`}
								value={item.minValue}
								onChange={(value) => setBoundary(i - 1, value)}
							/>
						)}
						{i === classes.length - 1 ? (
							<span className={styles.classEmpty}>—</span>
						) : (
							<ValueInput label={`${name} - até`} value={item.maxValue} onChange={(value) => setBoundary(i, value)} />
						)}
					</div>
				);
			})}
		</div>
	);
};
